module.exports = __webpack_public_path__ + "static/media/tutorial-buddy.4796cad1.svg";